"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAllFonts = void 0;
const tslib_1 = require("tslib");
const Font = tslib_1.__importStar(require("expo-font"));
const loadAllFonts = async (fonts) => {
    Font.loadAsync(fonts);
};
exports.loadAllFonts = loadAllFonts;
